export const musicTherapySyllabus = {
  title: "Professional Music Therapy Certification",
  subtitle: "Certified Music Therapist Programme",
  eligibility: "Candidate should be a Graduate from any stream to appear for this Certification Exam.",
  description: "To become a Certified Music Therapist and to pass this Certification Exam, candidates should have knowledge of the following topics:",
  topics: [
    "Principles and scope of music therapy",
    "History and foundations of music therapy practices",
    "Basics of psychology relevant to music therapy",
    "Emotional, cognitive, and behavioral responses to music",
    "Elements of music: rhythm, melody, harmony, and tempo",
    "Therapeutic use of voice and musical instruments",
    "Music therapy techniques for stress, anxiety, and emotional wellbeing",
    "Introduction to sound healing and relaxation methods",
    "Session planning, goal setting, and assessment techniques",
    "Client observation, progress evaluation, and documentation",
    "Ethical standards, professional boundaries, and confidentiality",
    "Safety considerations and contraindications in music therapy",
    "Case study understanding and practical application",
    "Role and responsibilities of a music therapy practitioner",
  ],
  gradingGuidelines: {
    title: "Grading Guidelines (Total: 100 Marks)",
    subtitle: "Professional Music Therapy Certification",
    sections: [
      {
        number: 1,
        title: "Theory Examination – 40 Marks",
        assessmentType: "MCQs / Short answers",
        items: [
          { name: "Fundamentals of Music Therapy", marks: 10 },
          { name: "Psychology & Emotional Response to Music", marks: 10 },
          { name: "Music Elements & Therapeutic Application", marks: 10 },
          { name: "Ethics, Safety & Professional Practice", marks: 10 },
        ],
      },
      {
        number: 2,
        title: "Practical Examination – 30 Marks",
        assessmentType: "Live demonstration",
        items: [
          { name: "Therapeutic Use of Voice & Instruments", marks: 10 },
          { name: "Application of Music Therapy Techniques", marks: 10 },
          { name: "Session Planning & Delivery", marks: 10 },
        ],
      },
      {
        number: 3,
        title: "Case Study / Assignment – 20 Marks",
        assessmentType: "Written / Presentation",
        items: [
          { name: "Case Understanding & Goal Identification", marks: 10 },
          { name: "Therapy Plan & Outcome Evaluation", marks: 10 },
        ],
      },
      {
        number: 4,
        title: "Viva Voce / Oral Assessment – 10 Marks",
        assessmentType: null,
        items: [
          { name: "Concept clarity and practical understanding", marks: 5 },
          { name: "Professional communication & ethical awareness", marks: 5 },
        ],
      },
    ],
    passingCriteria: {
      title: "Passing Criteria & Grade Classification",
      minimumPassing: "Minimum Passing Marks: 40 out of 100",
      practicalMinimum: "Minimum Marks in Practical: 15 out of 30 (mandatory)",
    },
    gradeScale: [
      { range: "90 – 100", grade: "Distinction" },
      { range: "75 – 89", grade: "First Class with Merit" },
      { range: "60 – 74", grade: "First Class" },
      { range: "40 – 59", grade: "Pass" },
      { range: "Below 40", grade: "Fail" },
    ],
  },
};
